
























































import { Component, Prop, Vue } from "vue-property-decorator";
import PdfPenunjang from "@/components/pemeriksaan/penunjang/Pdf.vue";
import pdf from "vue-pdf";

@Component({
  components: {
    PdfPenunjang,
    pdf
  }
})
export default class ZoomModal extends Vue {
  @Prop() item;
  @Prop() value!: boolean;
  //   @Prop() openDialog!: boolean;

  page = 1;
  numPages = 0;
  tipe = "";
  nextPage() {
    if (this.page + 1 <= this.numPages) this.page += 1;
  }
  formerPage() {
    if (this.page - 1 >= 1) this.page -= 1;
  }
  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }
  close() {
    this.dialog == false;
    this.$emit("dialogopen", false);
  }
}
